import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const HomeCardLayout = ({ icon, link, title, description, button, allowed = true }) => {
    return (
        <div className="home-card">
            <div className="flex flex-wrap w-full ">
                <div className="w-full lg:w-1/4 p-2">
                    <FontAwesomeIcon icon={icon} className="text-custom-main text-2xl md:text-4xl rounded-full bg-white p-6 md:p-10" />
                </div>
                <div className="w-full lg:w-3/4 p-2">
                    <h1 className="font-bold text-xl text-white">
                        {title}
                    </h1>
                    <p className="text-sm text-white">
                        {description}
                    </p>
                    <br />
                    <div className="flex justify-end">
                        {allowed &&
                            <Link to={link} className="btn btn-main w-32">
                                {button}
                            </Link>
                        }
                        {!allowed &&
                            <button className="btn btn-main w-32" disabled>
                                No disponible
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeCardLayout;
